import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgStep5 = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="currentColor"
      d="M16.003 21.792c-.714 0-1.322-.09-1.824-.272-.49-.181-.896-.421-1.216-.72-.32-.31-.56-.661-.72-1.056a3.903 3.903 0 01-.24-1.264h2.4c.032.384.176.699.432.944.267.235.656.352 1.168.352 1.174 0 1.76-.661 1.76-1.984 0-.352-.048-.65-.144-.896a1.584 1.584 0 00-.384-.592 1.399 1.399 0 00-.56-.32 2.022 2.022 0 00-.672-.112c-.373 0-.683.07-.928.208a1.657 1.657 0 00-.592.56h-2.24V10.4h7.296v1.984h-4.896v2.048A1.94 1.94 0 0115.46 14c.33-.096.699-.144 1.104-.144.544 0 1.035.085 1.472.256.448.16.827.405 1.136.736.32.33.566.741.736 1.232.17.49.256 1.056.256 1.696 0 .608-.101 1.163-.304 1.664a3.53 3.53 0 01-.832 1.264c-.363.352-.8.624-1.312.816a5.1 5.1 0 01-1.712.272z"
    />
  </svg>
));
SvgStep5.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStep5;
